var _rect, _rect2, _path, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloaticonestadistica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 113,
    fill: "none",
    viewBox: "0 0 103 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101.667,
    height: 112.112,
    x: 0.5,
    y: 0.556,
    fill: "#fff",
    fillOpacity: 0.15,
    rx: 11.223
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 78.521,
    height: 78.521,
    x: 12.073,
    y: 17.351,
    fill: "#F2F1FF",
    rx: 11.142
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6F4EF6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51,
    d: "M31.63 75.44h39.407M39.649 56.174h-5.255a1.313 1.313 0 0 0-1.313 1.313V75.44h7.882V57.487a1.313 1.313 0 0 0-1.314-1.313ZM53.96 37.783h-5.254a1.314 1.314 0 0 0-1.314 1.314V75.44h7.882V39.097a1.314 1.314 0 0 0-1.313-1.314Zm14.312 7.882h-5.254a1.313 1.313 0 0 0-1.314 1.314V75.44h7.882V46.98a1.313 1.313 0 0 0-1.314-1.314Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 101.394,
    height: 111.839,
    x: 0.637,
    y: 0.692,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 0.273,
    rx: 11.087
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloaticonestadistica);
export default __webpack_public_path__ + "static/media/float icon estadistica.24bf1db2f0a78bb1084aaee90af20fba.svg";
export { ForwardRef as ReactComponent };